import React from 'react';
import { Layout, Table, Button, Card } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import languages from '../../constants/languages';
import { getContacts, sendTestEmail, removeContact } from '../../services/user';
import { toast } from 'react-toastify';

const Contact  = (props) => {
    const [data, setData] = React.useState(null);

    React.useEffect(() => {
        getContactList();

        return () => {
            setData(null);
        }        
    }, []);
    function getContactList() {
        getContacts().then(res => {
            if(res.status === 1){
                setData(res.data);
            } else {
                toast.error(res.message);
            }
        });

    }

    const onClickRemove = (contact) => {
        removeContact(contact._id).then(res => {
            if(res.status === 1){
                getContactList();
                toast.success(languages.removeContactSuccess);
            } else {
                toast.error(res.message);
            }
        })
    };

    const onClickCreate = () => {
        props.history.push(`${process.env.PUBLIC_URL}/contact/create`);
    };

    const onClickName = record => {
        props.history.push(`${process.env.PUBLIC_URL}/contact/detail/${record._id}`);
    };

    const onClickTestMail = record => {
        setData(data.map(dt => dt._id === record._id ? { ...dt, loading: true}: dt));
        sendTestEmail(record._id).then(res => {
            if(res.status === 1){
                toast.success(languages.sendMailSuccess);
            } else {
                toast.error(res.message);
            }
            setData(data.map(dt => dt.id === record.id ? { ...dt, loading: false}: dt));
        })
    };

    const columns =  [
        {
          title: languages.titleColumnContactName,
          dataIndex: 'name',
          key: 'name',
          sorter: {
            compare: (a, b) => a.name.localeCompare(b.name),
            multiple: 2,
          },   
          width: '35%',
          showSorterTooltip: false,
          render: (text, record) => <a onClick={() => onClickName(record)}>{text}</a>
        },
        {
          title: languages.titleColumnContactEmail,
          dataIndex: 'email',
          key: 'email',
          width: '35%',
          sorter: {
            compare: (a, b) => a.email.localeCompare(b.email),
            multiple: 2,
          },      
          showSorterTooltip: false    
        },
        {
            title: '',
            key: 'action',
            width: '30%',
            render: record =>   
                            <>
                                <Button 
                                    type="primary" 
                                    className="tbl-btn" 
                                    onClick={() => onClickRemove(record)}>{languages.btnRemoveContact}</Button>                            
                                <Button 
                                    type="primary" 
                                    className="tbl-btn" 
                                    loading={record.loading}
                                    onClick={() => onClickTestMail(record)}>{languages.btnTestEmail}</Button>
                            </>
        }
    ];

    if(!data){
        return <div>Loading...</div>
    }

    return (
        <Layout className="layout-server">
            <Card
                title={languages.titleContact}
                className="flex-1"
            >  
                <div className="row justify-end">
                    <Button 
                        icon={<PlusOutlined />} 
                        className="btn-success" 
                        type="primary"
                        onClick={onClickCreate}
                    >{languages.btnAddContact}</Button>
                </div>
                <Table 
                    dataSource={data} 
                    columns={columns} 
                    bordered={true} 
                    rowKey={"_id"} 
                    pagination={false} 
                />
            </Card>            
        </Layout>
    );
};

export default Contact;